export default function CTABanner() {
  return (
    <section className="py-32 px-4 sm:px-6 lg:px-8 bg-[#0a0a0a] relative">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-gray-700/60 to-transparent"></div>
      <div className="max-w-5xl mx-auto">
        <div className="relative overflow-hidden rounded-3xl border border-gray-800/80 bg-gradient-to-br from-gray-900/80 via-gray-900/60 to-gray-900/80 backdrop-blur-sm p-16 text-center">
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_80%_80%_at_50%_50%,rgba(20,184,166,0.15),transparent)]"></div>
          <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-teal-500/60 to-transparent"></div>
          <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-teal-500/40 to-transparent"></div>
          
          <div className="relative z-10">
            <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center bg-teal-500/10 rounded-2xl border border-teal-500/20">
              <i className="ri-rocket-2-line text-3xl text-teal-400"></i>
            </div>
            <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-5 tracking-tight leading-tight">
              Ready to Find Your Next AI Tool?
            </h2>
            <p className="text-base md:text-lg text-gray-400 max-w-2xl mx-auto leading-relaxed mb-10">
              Discover powerful AI tools that transform your workflow and boost productivity.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4">
              <a
                href="#tools-directory"
                className="inline-flex items-center gap-2.5 px-8 py-4 bg-teal-500 hover:bg-teal-400 text-white text-base font-semibold rounded-xl transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-teal-500/30 hover:shadow-teal-400/40 hover:scale-105 active:scale-95"
              >
                Explore AI Tools
                <i className="ri-arrow-right-line text-lg"></i>
              </a>
              <a
                href="#submit-tool"
                className="inline-flex items-center gap-2.5 px-8 py-4 bg-transparent hover:bg-teal-500/10 text-teal-400 hover:text-teal-300 text-base font-semibold rounded-xl transition-all duration-300 whitespace-nowrap cursor-pointer border border-teal-500/40 hover:border-teal-500/60"
              >
                Submit a Tool
                <i className="ri-add-circle-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-gray-700/60 to-transparent"></div>
    </section>
  );
}